import { ArrowDown } from '@carbon/icons-react';
import { GitHubProvisioningStatus } from '@gql/gql-types';
import { Alert, Link, Typography } from '@mui/material';

import { Assessment, GitHubProvisioning } from '../gihub-coding-page';
import { RefetchFn } from '../utils';
import { GithubCodingCard } from './github-coding-components';
import { GithubCodingCurrentAction } from './github-coding-current-action';

export const GithubCodingActions = ({
  assessment,
  provisioning,
  refetch,
  isRefetching,
}: {
  assessment: Assessment;
  provisioning?: GitHubProvisioning | null;
  refetch: RefetchFn;
  isRefetching: boolean;
}) => {
  const status = provisioning?.status;
  if (status === GitHubProvisioningStatus.Error) {
    return (
      <GithubCodingCard>
        <Alert severity='error'>
          Something went wrong. Please refresh the page or if the issue
          persists,{' '}
          <Link href='mailto:support@alignerr.com'>contact support</Link>.
        </Alert>
      </GithubCodingCard>
    );
  }

  return (
    <GithubCodingCard>
      <Typography
        variant='h6'
        sx={{ mb: 2, display: 'flex', alignItems: 'center' }}
      >
        <ArrowDown size={20} />
        <span style={{ marginLeft: 8 }}>Next step</span>
      </Typography>
      <GithubCodingCurrentAction
        assessment={assessment}
        provisioning={provisioning}
        refetch={refetch}
        isRefetching={isRefetching}
      />
    </GithubCodingCard>
  );
};
